module.exports = __webpack_public_path__ + "img/15.e3f8ca41.png";